import { render, staticRenderFns } from "./CXCdetails.vue?vue&type=template&id=77b574d4&"
import script from "./CXCdetails.vue?vue&type=script&lang=js&"
export * from "./CXCdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports